import React from "react";
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from "primereact/button";
import "../../style/notification.css"
import { Checkbox } from "primereact/checkbox";
import service from "../../utils/service";
import moment from "moment"
import { Toast } from 'primereact/toast';
import { Paginator } from 'primereact/paginator';
import AccordionLoader from '../common/AccordionLoader';
function Notification(props){
  const [text, setText] = React.useState("")
  const [notifIndex, setNotifIndex] = React.useState(-1)
  const [sendEmail, setSendEmail] = React.useState(true)
  const [saving, setSaving] = React.useState(false)
  const [loading, setLoading] = React.useState(true)
  const [first, setFirst] = React.useState(0);
  const [rows, setRows] = React.useState(10);

  const toast = React.useRef(null);
  const [notifs, setNotifs] = React.useState([])

  const getNotificationHistory = () => {
    setLoading(true);
    service.getNotificationHistory().then((response) => {
      setNotifs(response.data);
      setLoading(false)
    });
  }
  React.useEffect(getNotificationHistory, []);

  var getIndexes = () => {
    let arr = [], id = first
    for(var i=0;i<rows;i++){
      if(id >= notifs.length) break;
      arr.push(id);
      id++;
    }
    return arr;
  }

  return(
    <div className="app__grid main-box">
      <Toast ref={toast} baseZIndex={20000} />
      <div className="grid">
        <form 
          className="col-3" 
          id="notif-form"
          onSubmit={(event)=> {
            event.preventDefault()
            setSaving(true)
            var json = {}
            json.message = text;
            setText("")
            json.isEmailNotification = sendEmail
            json.email = props.email
            service.saveCommodityNotification(json).then(response => {
              toast.current.show({severity:'success', summary: 'Success', detail:'Notification published successfully', life: 3000});
              getNotificationHistory();
              setSaving(false);
            }).catch((error) => {
              toast.current.show({severity:'error', summary: 'Error', detail:'Error while publishing notification', life: 3000});
              console.error(error);
              setSaving(false);
            });
          }}
        >
          <h3 className="text-center">Publish Notification</h3>
          <InputTextarea
            value = {text}
            className="widthFull"
            rows="10"
            onChange = {(event) => setText(event.target.value)}
            required
          />
          <div className="field-checkbox sm:col-12 mb-0">
            <Checkbox
              onChange={(e) => setSendEmail(e.checked)}
              checked={sendEmail}
            />
            <label>
              <p onClick = {() => {
                setSendEmail( prev => !prev)
              }}>
                Send email along with Mobile Notification</p>
            </label>
          </div>
          <div className="text-center">
            <Button label="Publish" 
              className="publish"
              type="submit"
              form="notif-form"
            />
            { saving && <i className="pi pi-spin pi-spinner" style={{'fontSize': '2em'}}></i>}
          </div>
        </form>
        <div className="col"></div>
        <div className="col-8">
          <h3 className="text-center">Notification History</h3>
          {loading && <AccordionLoader />}
          { !loading &&
            getIndexes().map((index) => {
              var notif = notifs[index]
              return (
                <div className="grid">
                  <div className="col">
                    <div className="box">

                    <i className="pi pi-bell notif-bell"></i>
                      <div style={{ fontWeight: 600}}>
                        {notif.username}
                        <span
                          onClick={() => {
                            if(notifIndex === index) setNotifIndex(-1)
                            else setNotifIndex(index)
                          }}
                          className="floatRight vertical-center"
                        >
                          { notifIndex === index ? <i className="pi pi-chevron-up"></i> : <i className="pi pi-chevron-down"></i>}
                        </span>
                      </div>
                      <span className="notif-date">Published on {moment(notif.createdTimestamp).format('MMMM Do YYYY')}</span>


                      { notifIndex === index && (
                        <div className="seperatorContent">
                          {notif.message}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )})
          }
          { !loading && notifs.length === 0 ?
              <div className="drag-description">No data to show</div>
            :
              !loading && <Paginator first={first} rows={rows} totalRecords={notifs.length} rowsPerPageOptions={[10, 20, 50]} onPageChange={(e) => {setFirst(e.first); setRows(e.rows)}}></Paginator>
          }
        </div>
      </div>
    </div>
  )
}

export default Notification
